import { render, staticRenderFns } from "./ResetPasswordTwo.vue?vue&type=template&id=0027d3f9&scoped=true&"
import script from "./ResetPasswordTwo.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordTwo.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordTwo.vue?vue&type=style&index=0&id=0027d3f9&prod&lang=less&scoped=true&"
import style1 from "./ResetPasswordTwo.vue?vue&type=style&index=1&id=0027d3f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027d3f9",
  null
  
)

export default component.exports